import React, { Suspense, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import MainLayout from '../../components/core/layouts/MainLayout';
import { RootState } from '../../store';
import { AUTH_ROUTER } from '../../routers/constants';

import LoadingScreen from 'components/core/common/Loading';

interface Props {
  children: React.ReactNode;
}

function WithMainLayoutHOC({ children }: Props) {
  const navigate = useNavigate();

  const { isAuth } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    if (!isAuth) {
      navigate(AUTH_ROUTER.LOGIN);
    }
  }, [isAuth, navigate]);

  return (
    <MainLayout>
      <Suspense fallback={<LoadingScreen />}>{children}</Suspense>
    </MainLayout>
  );
}

export default WithMainLayoutHOC;
